import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { GatsbyImage } from "gatsby-plugin-image";
import { default as CTAComponent } from "../cta/cta";

export const HeroBase = styled.section`
  max-width: ${theme.maxSectionWidth};
  margin: 0 auto;
  background-size: cover;
  background-position: center top;

  ${theme.smallerThan.md} {
    background-image: none !important;
  }

  ${theme.largerThan["3xl"]} {
    border-radius: 16px;
  }
`;

export const HeroImage = styled(GatsbyImage)`
  ${theme.largerThan.md} {
    display: none;
  }
`;

export const HeroContent = styled.div`
  display: grid;
  gap: ${theme.spacing[4]};

  h1 {
    margin: 0;
    color: ${theme.colors.blues[100]};
  }

  ${theme.largerThan.lg} {
    gap: ${theme.spacing[8]};
  }
`;

export const CTAButton = styled(CTAComponent)<{}>`
  padding: ${theme.spacing[2]} ${theme.spacing[8]} !important;
  background-color: ${theme.colors.yellows[100]};
  color: ${theme.colors.black};
  border-color: ${theme.colors.yellows[100]};

  ${theme.largerThan.lg} {
    ${theme.text.base};
    transition: all 0.1s ease-out;

    &:hover {
      transform: scale(1.02);
    }
  }
`;
